// export const LOCATION_PASS_OPTION = {
//   reason: 'location',
//   text: 'Location is too far',
// };

export const SCHEDULE_PASS_OPTION = {
  reason: 'schedule',
  text: 'I\'m too busy',
};

// export const SMALL_PASS_OPTION = {
//   reason: 'small',
//   text: 'Job too small',
// };

export const SUBTASK_PASS_OPTION = {
  reason: 'subtask',
  text: 'Not my type of work',
};

export const OTHER_PASS_OPTION = {
  reason: 'other',
  text: 'Other',
};


export const PASS_OPTIONS = [
  // LOCATION_PASS_OPTION,
  SCHEDULE_PASS_OPTION,
  // SMALL_PASS_OPTION,
  SUBTASK_PASS_OPTION,
  OTHER_PASS_OPTION,
];
